export function arrayRotate<T extends Array<any>>(arr: T, count: number) {
  const rotated = arr.slice();
  count -= rotated.length * Math.floor(count / rotated.length);
  rotated.push(...rotated.splice(0, count));
  return rotated as T;
}
